import { Card, Flex, rem, Skeleton } from "@mantine/core"




const ModelCardSkeleton = () => {


    return (
        <Card
            radius={rem(16)}
            p={0}
            pos="relative"
        >
            <Card p={0} radius="0 0 16px 16px" h={{ base: rem(200), sm: rem(300) }}>
                <Skeleton
                    visible
                    animate
                    width="100%"
                    height="100%"
                />
            </Card>

            <Flex direction="column" py={rem(16)} px={rem(14)}>
                <Flex align="center" justify="space-between" style={{ borderBottom: "1px solid #DFDFDF" }} py="xs">
                    <Skeleton
                        visible
                        animate
                        width="100%"
                        height={32}
                    />
                </Flex>

                <Flex align="center" justify="space-between" py="xs" gap="sm">
                    <Skeleton
                        visible
                        animate
                        width="30%"
                        height={32}
                    />

                    <Skeleton
                        visible
                        animate
                        width="30%"
                        height={32}
                    />
                </Flex>
            </Flex>

        </Card>
    )
}

export default ModelCardSkeleton